import type {
	BaseEventPayload,
	DropTargetGetFeedbackArgs,
	DropTargetLocalizedData,
	ElementDragType,
} from "@atlaskit/pragmatic-drag-and-drop/dist/types/internal-types";
import { extractClosestEdge } from "@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge";
import type { DraggableItem, DroppablePayload, DroppablePayloadBase } from "./types";

export type OnDropItem = BaseEventPayload<ElementDragType> & DropTargetLocalizedData;

export function getDraggableType(dropItem: OnDropItem): DraggableItem {
	/** Return */
	return dropItem.source.data.type as DraggableItem;
}

export function getDroppablePayload<T>(
	element:
		| DroppablePayloadBase
		| BaseEventPayload<ElementDragType>
		| DropTargetGetFeedbackArgs<any>,
) {
	const payload = element as DroppablePayload<T>;
	return payload.source.data;
}

export function getClosestEdge(payload: DroppablePayloadBase) {
	return extractClosestEdge(payload.self.data);
}
